import React from "react";

function Invite() {
  
  const handleDeepLinking = async (url) => {
    const isSupported = await checkIfLinkingIsSupported(url);
    if (isSupported) {
    } else {
      const platform = getPlatform();
      let appStoreUrl;

      switch (platform) {
        // case "android":
        //   appStoreUrl =
        //     "https://play.google.com/store/apps/details?id=your.package.name"; // Replace with your app's package name
        //   break;

        // case "ios":
        //   appStoreUrl = "https://apps.apple.com/app/your-app-id"; // Replace with your app's App Store ID
        //   break;

        default:
          // Default URL for other platforms or when platform is not specified
          appStoreUrl = "https://soorx.com";
          break;
      }

      redirectToAppStore(appStoreUrl);
    }
  };

  const checkIfLinkingIsSupported = async (url) => {
    return (
      typeof navigator !== "undefined" &&
      typeof navigator.userAgent === "string" &&
      typeof window !== "undefined" &&
      "Linking" in window
    );
  };

  const getPlatform = () => {
    const ua = navigator.userAgent;
    if (/android/i.test(ua)) {
      return "android";
    } else if (
      /iPad|iPhone|iPod/.test(ua) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
    ) {
      return "ios";
    }
    return "other";
  };

  const redirectToAppStore = (appStoreUrl) => {
    window.location.href = appStoreUrl;
  };
  const fullUrl = window.location.href;
  handleDeepLinking(fullUrl);
  return <div></div>;
}

export default Invite;
